import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { HttpError } from 'ish-core/models/http-error/http-error.model';
import { OrderListQuery } from 'ish-core/models/order-list-query/order-list-query.model';
import { Order } from 'ish-core/models/order/order.model';
import { setErrorOn, setLoadingOn, unsetLoadingAndErrorOn } from 'ish-core/utils/ngrx-creators';

import {
  createMultipleShippingOrder,
  createMultipleShippingOrderSuccess,
  createOrder,
  createOrderFail,
  createOrderSuccess,
  loadCustomOrders,
  loadOrder,
  loadOrderFail,
  loadOrderSuccess,
  loadOrders,
  loadOrdersFail,
  loadOrdersSuccess,
  resetOrderErrors,
  resetOrders,
  selectOrder,
} from './orders.actions';

export const orderAdapter = createEntityAdapter<Order>({
  selectId: order => order.id,
});

export interface OrdersState extends EntityState<Order> {
  loading: boolean;
  selected: string;
  query: OrderListQuery;
  moreAvailable: boolean;
  error: HttpError;
}

const initialState: OrdersState = orderAdapter.getInitialState({
  loading: false,
  selected: undefined,
  query: undefined,
  moreAvailable: true,
  error: undefined,
});

export const ordersReducer = createReducer(
  initialState,
  setLoadingOn(createOrder, loadOrder, loadOrders, createMultipleShippingOrder, loadCustomOrders),
  unsetLoadingAndErrorOn(createOrderSuccess, loadOrderSuccess, loadOrdersSuccess, createMultipleShippingOrderSuccess),
  setErrorOn(loadOrdersFail, loadOrderFail, createOrderFail),
  on(
    selectOrder,
    (state, action): OrdersState => ({
      ...state,
      selected: action.payload.orderId,
    })
  ),

  on(createOrderSuccess, loadOrderSuccess, createMultipleShippingOrderSuccess, (state, action) => {
    const { order } = action.payload;

    return {
      ...orderAdapter.upsertOne(order, state),
      selected: order.id,
    };
  }),
  /* DIAS CUSTOMIZATION START */
  on(loadOrdersSuccess, (state, action) => {
    const { orders, query, allRetrieved } = action.payload;
    const newState = { ...state, query, moreAvailable: !allRetrieved };
    if (!query?.offset) {
      return orderAdapter.setAll(orders, newState);
    } else {
      return orderAdapter.addMany(orders, newState);
    }
  }),
  on(resetOrders, state => ({
    ...orderAdapter.removeAll(state),
  })),
  /* DIAS CUSTOMIZATION END */
  on(
    resetOrderErrors,
    (state): OrdersState => ({
      ...state,
      error: undefined,
    })
  )
);
